import { render, staticRenderFns } from "./vSlider.vue?vue&type=template&id=2826a27e&scoped=true"
import script from "./vSlider.vue?vue&type=script&lang=js"
export * from "./vSlider.vue?vue&type=script&lang=js"
import style0 from "./vSlider.vue?vue&type=style&index=0&id=2826a27e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2826a27e",
  null
  
)

export default component.exports